module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/forest-f8b686b233a0aa55e876b061f3383c46.png";